function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEraserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M 19 2.015625 C 18.117477 2.015625 17.235919 2.3500183 16.568359 3.0175781 L 3.0195312 16.568359 C 1.6844117 17.903479 1.6844117 20.098474 3.0195312 21.433594 L 7.5683594 25.982422 C 8.1585464 26.572609 8.9178476 26.88677 9.6953125 26.955078 A 1.0001 1.0001 0 0 0 10 27 L 18 27 A 1.0001 1.0001 0 1 0 18 25 L 13.414062 25 L 25.982422 12.431641 C 27.317541 11.096521 27.317541 8.901526 25.982422 7.5664062 L 21.433594 3.0175781 C 20.766034 2.3500183 19.882523 2.015625 19 2.015625 z M 10.707031 11.707031 L 17.292969 18.292969 L 11.017578 24.568359 C 10.44645 25.139487 9.5535496 25.139487 8.9824219 24.568359 L 4.4335938 20.019531 C 3.8627133 19.448651 3.8627133 18.553302 4.4335938 17.982422 L 10.707031 11.707031 z M 22 25 A 1 1 0 0 0 21 26 A 1 1 0 0 0 22 27 A 1 1 0 0 0 23 26 A 1 1 0 0 0 22 25 z M 26 25 A 1 1 0 0 0 25 26 A 1 1 0 0 0 26 27 A 1 1 0 0 0 27 26 A 1 1 0 0 0 26 25 z",
    fontWeight: 400,
    fontFamily: "sans-serif",
    "white-space": "normal",
    overflow: "visible"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserIcon);
export default __webpack_public_path__ + "static/media/eraserIcon.0ac1365ad191b26173356c5e74136d5e.svg";
export { ForwardRef as ReactComponent };